import * as filters from '@/common/filters';
import log from '@/logger';

export const currentProject = (state, getters) => {
  return state.currentProject;
};

export const currentProjectUserItem = (state) => (occupation) => {
  return (
    state.currentProject.projectManagers.find((i) => i.occupation === occupation) ||
    state.currentProject.projectSubcontractors.find((i) => i.occupation === occupation) ||
    state.currentProject.aftermarkets.find((i) => i.occupation === occupation)
  );
};

export const currentProjectRoles = (state, getters) => {
  var list = [];

  if (!getters.currentProject) {
    return list;
  }

  if (getters.currentProject.projectManagers) {
    for (var manager of getters.currentProject.projectManagers) {
      if (manager.occupation && manager.occupation !== '') {
        if (!list.includes(manager.occupation)) {
          list.push(manager.occupation);
        }
      }
    }
  }

  if (getters.currentProject.projectSubcontractors) {
    for (var subcontractor of getters.currentProject.projectSubcontractors) {
      if (subcontractor.occupation && subcontractor.occupation !== '') {
        if (!list.includes(subcontractor.occupation)) {
          list.push(subcontractor.occupation);
        }
      }
    }
  }

  if (getters.currentProject.aftermarkets) {
    for (var aftermarket of getters.currentProject.aftermarkets) {
      if (aftermarket.occupation && aftermarket.occupation !== '') {
        if (!list.includes(aftermarket.occupation)) {
          list.push(aftermarket.occupation);
        }
      }
    }
  }

  return list;
};

export const projectBuildingTypes = (state, getters) => {
  var list = [];
  for (var project of getters.projectList) {
    if (project.buildingType && project.buildingType !== '') {
      if (!list.includes(project.buildingType)) {
        list.push(project.buildingType);
      }
    }
  }
  return list;
};

export const projectTypes = (state, getters) => {
  var list = [];
  for (var project of getters.projectList) {
    if (project.projectType && project.projectType !== '') {
      if (!list.includes(project.projectType)) {
        list.push(project.projectType);
      }
    }
  }
  return list;
};

export const projectIds = (state, getters) => {
  var list = [];
  for (var project of getters.projectList) {
    list.push(project._id);
  }
  return list;
};

export const projectIdList = (state, getters) => {
  var list = [];
  for (var project of getters.projectList) {
    list.push({ _id: project._id, title: project.title });
  }
  return list;
};

export const projectList = (state, getters) => {
  if (!state.projectList || !state.loggedInPerson.projects) {
    return [];
  }
  var a = state.projectList.slice();

  var personProjects = state.loggedInPerson.projects.map((p) => p._id);
  a = a.filter((element, index) => {
    return !element.archived && (getters.isAdmin || personProjects.includes(element._id));
  });

  a.sort((a, b) => {
    var t1 = (a.projectNumber ? a.projectNumber.replace(/\s/g, '').padStart(10, '0') : 'zzzzzzzzzz') + a.title + a._id;
    var t2 = (b.projectNumber ? b.projectNumber.replace(/\s/g, '').padStart(10, '0') : 'zzzzzzzzzz') + b.title + b._id;
    return t1.localeCompare(t2);
  });

  return a;
};

export const getProject = (state) => (id) => {
  const project = state.projectList.find(({ _id }) => _id === id);
  if (project) {
    return project;
  }

  log.info('projectGetters::getProject:not found', [id]);

  // return { title: 'Unknown: ' + id, _id: id };
  return null;
};

export const filterParts = (state) => (filter) => {
  if (!state.currentProject) {
    return [];
  }

  let r = filters.filterParts(
    state,
    state.currentProject,
    filter.filterText,
    filter.filterDate,
    filter.filterDateEnd,
    filter
  );

  return r.children;
};



// WEBPACK FOOTER //
// ./src/store/project/projectGetters.js